<template>
	<b-modal
		size="md"
		ref="update-specimen-location-modal"
		@hidden="$emit('close')"
		ok-title="Guardar"
		:title="`Asignar Nueva Ubicación de ${specimen.plate} ${specimen.alias ? '(' + specimen.alias + ')' : ''}`"
		centered
		@ok.prevent="saveSpecimenLocation"
		:ok-disabled="location_id == original_location_id"
		no-close-on-backdrop
	>
		<validation-observer ref="form">
			<b-row>
				<b-col cols="4" class="d-flex align-items-center">
					<strong>Area:</strong>
				</b-col>
				<b-col cols="8" class="d-flex align-items-center">
					<v-select
						v-model="area_id"
						label="name"
						class="mx-1"
						:options="locationAreas"
						:reduce="(opt) => opt.id"
						style="width: 220px"
						placeholder="Seleccionar area"
						:clearable="false"
						@input="changeArea"
					/>
				</b-col>
			</b-row>
			<b-row class="mt-2">
				<b-col cols="4" class="d-flex align-items-center">
					<strong>Tipo:</strong>
				</b-col>
				<b-col cols="8" class="d-flex align-items-center">
					<v-select
						v-model="location_type"
						label="name"
						class="mx-1"
						:options="locationTypes"
						:reduce="(opt) => opt.id"
						style="width: 220px"
						placeholder="Seleccionar tipo"
						:clearable="false"
						@input="changeLocation"
					/>
				</b-col>
			</b-row>
			<b-row class="mt-2">
				<b-col cols="4" class="d-flex align-items-center">
					<strong>Ubicación:</strong>
				</b-col>
				<b-col cols="8" class="d-flex align-items-center">
					<ValidationProvider rules="required" v-slot="{ errors }">
						<v-select
							v-model="location_id"
							label="name"
							class="mx-1"
							:class="{
								'border-danger rounded': errors[0],
							}"
							:options="locations"
							:reduce="(opt) => opt.id"
							:clearable="false"
							style="width: 220px"
							placeholder="Seleccionar ubicación"
						/>
					</ValidationProvider>
				</b-col>
			</b-row>
		</validation-observer>
	</b-modal>
</template>

<script>
import modalMixin from "@/mixins/modal.js"
import SpecimenLocationService from "@/views/brain/specimens/views/location/services/specimen-location.service.js"
export default {
	name: "UpdateSpecimenLocationModal",
	props: {
		specimen: Object,
	},
	components: {},
	async mounted() {
		this.toggleModal("update-specimen-location-modal")
	},
	data() {
		return {
			original_location_id: null,
			location_id: null,
			area_id: null,
			locationAreas: [
				{
					id: 1,
					name: "Preparación",
				},
				{
					id: 2,
					name: "Encaste",
				},
			],
			locationTypes: [
				{
					id: 1,
					name: "Casilla",
				},
				{
					id: 2,
					name: "Rascadero",
				},
				{
					id: 3,
					name: "Voladero",
				},
			],
			locations: [],
			location_type: null,
		}
	},

	methods: {
		async saveSpecimenLocation() {
			const validate = await this.$refs.form.validate()
			if (!validate) return
			try {
				this.isPreloading()
				await SpecimenLocationService.saveSpecimenLocation({
					specimen_id: this.specimen.id,
					location_id: this.location_id,
				})
				this.specimen.specimen_location_id = this.location_id
				this.specimen.specimen_location_type_id = this.location_type
				this.specimen.location_name = this.locations.find((loc) => loc.id === this.location_id).name
				this.specimen.location_area_name = this.locationAreas.find((area) => area.id === this.area_id).name
				this.$emit("close")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		changeArea(e) {
			this.location_type = null
			this.location_id = null
		},
		changeLocation(e) {
			this.location_id = null
			if (this.area_id) {
				this.getLocations()
			}
		},
		async getLocations() {
			this.isPreloading()
			try {
				const { data } = await SpecimenLocationService.getLocations({
					type_id: this.location_type,
					active: true,
					area_id: this.area_id,
				})
				this.locations = data
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	mixins: [modalMixin],
}
</script>

<style></style>
